<template>
  <div style="height:100vh; min-height:100vh;">
    <Header :key="'header'" :IsAdmin="IsAdmin" :IsTeacher="IsTeacher" :token="token" :name="name" v-on:logout="logout"></Header>
    <SideMenu />

  
      <router-view :key="'a' + $route.path" :token="token" v-on:setData="setData"/>
  
  </div>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
import Header from "./components/Header.vue";
import SideMenu from "./components/SideMenu.vue";

export default {
  name: "app",
  components: {
    Header,
    SideMenu
  },
  data: function() {
    return {
      token: null,//localStorage.getItem("token")
      IsAdmin: false,
      IsTeacher: false,
      name: null
    };
  },
  mounted: function() {
    document.title ="T-Time Education";
    if(localStorage.token) {
      //JSON.parse(atob(localStorage.token.split('.')[1]))
      //check exp date vs now, determine if token gets thrown out

      this.token = localStorage.token;
    }

    if(localStorage.IsAdmin) {
      this.IsAdmin = localStorage.IsAdmin;
    }

    if(localStorage.IsTeacher) {
      this.IsTeacher = localStorage.IsTeacher;
    }
  },
  watch: {
    token(newToken) {
      localStorage.token = newToken;
    },
    IsAdmin(newIsAdmin) {
      localStorage.IsAdmin = newIsAdmin;
    },
    IsTeacher(newIsTeacher) {
      localStorage.IsTeacher = newIsTeacher;
    }
  },
  methods: {
    randomTransition(){
      var transitions = [
        "fade", "fade-in-up", "fade-in-right", "fade-in-down", "fade-in-left",
        "overlay-up", "overlay-right", "overlay-down", "overlay-left",
        "overlay-down-full", "overlay-right-full",  "overlay-up-full", "overlay-left-full", "overlay-up-down", "overlay-left-right",
        "flip-x", "flip-y", "zoom"
      ];
      return transitions[Math.floor(Math.random() * transitions.length)];
    },
    setData : function(data) {
      this.token = data.Token;
      this.IsAdmin = data.IsAdmin;
      this.IsTeacher = data.IsTeacher;
      this.name = data.name;
    },
    logout : function() {
      this.token = null;
      this.IsAdmin = false;
      this.IsTeacher = false;
      localStorage.clear();
    }
  }
};
</script>
<style type="text/css">
  :root{
    --transition-duration: .15s !important;
    /*background-color: #FF005A;*/
  }
</style>